var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.popWindows),function(popWindow){return _c('pop-window',{key:popWindow.name,ref:"pops",refInFor:true})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }